module.exports = __webpack_public_path__ + "img/06.ae1a1787.jpg";